export default __webpack_public_path__ + "9f1512622cd98320c45f00b97129f00e.ico";